var _path, _path2, _path3, _path4, _path5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMapPins(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 24.5C13.9087 24.5 12.3826 23.8679 11.2574 22.7426C10.1321 21.6174 9.5 20.0913 9.5 18.5",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 9.5C13.5 11.709 9.5 15.5 9.5 15.5C9.5 15.5 5.5 11.709 5.5 9.5C5.5 8.43913 5.92143 7.42172 6.67157 6.67157C7.42172 5.92143 8.43913 5.5 9.5 5.5C10.5609 5.5 11.5783 5.92143 12.3284 6.67157C13.0786 7.42172 13.5 8.43913 13.5 9.5V9.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.5 16.5C27.5 19.814 21.5 26 21.5 26C21.5 26 15.5 19.814 15.5 16.5C15.5 14.9087 16.1321 13.3826 17.2574 12.2574C18.3826 11.1321 19.9087 10.5 21.5 10.5C23.0913 10.5 24.6174 11.1321 25.7426 12.2574C26.8679 13.3826 27.5 14.9087 27.5 16.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.5 10.5C10.0523 10.5 10.5 10.0523 10.5 9.5C10.5 8.94772 10.0523 8.5 9.5 8.5C8.94772 8.5 8.5 8.94772 8.5 9.5C8.5 10.0523 8.94772 10.5 9.5 10.5Z",
    fill: "#212121"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 18.5C22.6046 18.5 23.5 17.6046 23.5 16.5C23.5 15.3954 22.6046 14.5 21.5 14.5C20.3954 14.5 19.5 15.3954 19.5 16.5C19.5 17.6046 20.3954 18.5 21.5 18.5Z",
    strokeMiterlimit: 10,
    strokeLinecap: "square"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMapPins);
export default __webpack_public_path__ + "static/media/MapPins.c11686f45c32ea1a75b77c672519f5cc.svg";
export { ForwardRef as ReactComponent };